import Vue from 'vue';

export default (el) =>
  new Vue({
    components: {
      'audio-single': () => import('./audio-single/audio-single.vue'),
      'vue-image': () => import('../vue-image/vue-image.vue'),
      'vue-image-v2': () => import('../vue-image-v2/vue-image-v2.vue'),
    },
    el,
  });
